export default function getResource(label, vars = []) {
    const resources = {
        done: 'Terminé',
        close: 'Fermer',
        cancel: 'Annuler',
        continue: 'Continuer',
        sephoraCreditCard: 'Carte de crédit Sephora',
        noThanks: 'Non, merci',
        acceptNow: 'Oui, cela m’intéresse',
        notMe: 'Pas moi',
        congratulations: 'Félicitations,',
        fromTheRewardsBazaar: 'De la Foire aux récompenses Rewards Bazaar®',
        droppingTimeText: 'Nous affichons les nouvelles récompenses tous les mardis et jeudis de 9 h à 17 h HP. Elles s’envolent à la vitesse de l’éclair, alors revenez souvent pour décrocher des expériences, des services personnalisés et des échantillons récompenses convoités.',
        oops: 'Oups',
        cannotExtendText: 'Nous n’avons pas pu prolonger votre session. Veuillez réessayer plus tard.',
        youEntered: 'Vous avez saisi :',
        recommended: 'Adresse suggérée pour une livraison plus précise :',
        useTheAddress: 'Utiliser l’adresse que j’ai saisie',
        extendSessionTitle: 'Prolonger la session?',
        extendSessionButton: 'Prolonger la session',
        sessionExpireText: `Votre session expirera dans ${vars[0]} minutes et ${vars[1]} secondes en raison de votre inactivité.`,
        keepAsEntered: 'Conserver la saisie',
        selectYourGift: 'Sélectionner votre cadeau',
        unableToApplyGift: 'Impossible d’appliquer ce cadeau. Veuillez essayer de nouveau.',
        selected: 'Sélectionné',
        change: 'Modifier',
        select: 'Sélectionner'
    };

    return resources[label];
}
